import { apiBaseQuery } from '@cognitranlimited/itis-web';
import { createApi } from '@reduxjs/toolkit/query/react';
export var vehicleCodesModuleApi = createApi({
    reducerPath: 'vehicleCodesApi',
    baseQuery: apiBaseQuery(),
    tagTypes: ['VehicleCodes'],
    endpoints: function (builder) { return ({
        getVehicleIgnitionKeyCode: builder.query({
            query: function (vin) {
                return "/vehicle/warranty/ignition-key-code/".concat(vin);
            },
            extraOptions: {
                timeout: 30000
            }
        }),
        getVehicleRadioCode: builder.query({
            query: function (vin) {
                return "/vehicle/warranty/radio-code/".concat(vin);
            },
            extraOptions: {
                timeout: 30000
            }
        }),
        getVehicleImmobilizerCode: builder.query({
            query: function (vin) {
                return "/vehicle/warranty/immobilizer-code/".concat(vin);
            },
            extraOptions: {
                timeout: 30000
            }
        }),
    }); }
});
